import { useEffect, useState } from 'react';
import { ModalProps } from '../../../../../../../components/modal/modal';
import { validateLang } from '../../../../../../../helpers/lang';
import { validate } from '../../../../../../../helpers/validate';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';
import { useDishStore } from '../../../../../../../store/use-dish-store';

export const useMenuInformerCreateDishModal = (props: ModalProps) => {
  const { t } = useLang();
  const [step, setStep] = useState(0);

  const { handleResetDish, fetchDish, postDish, putDish, isLoading, dish, handleUpdateDish } =
    useDishStore();

  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const dishId = params.dishId;
  const menuId = params.menuId;

  useEffect(() => {
    if (dishId) fetchDish(dishId);

    return () => {
      handleResetDish();
    };
  }, [dishId, fetchDish, handleResetDish]);

  const handlePrevStep = () => {
    const prevStep = step - 1;
    if (prevStep >= 0) {
      setStep(prevStep);
    } else {
      props.onClose();
    }
  };

  const handleNextStep = async () => {
    if (step === 0) {
      const isValid = validate({
        name: { rule: () => validateLang(dish?.name) },
        actual: {
          rule: () => {
            const { price } = dish?.prices?.primary || {};
            if (!price && price !== 0) return false;

            return price >= 0;
          },
        },
      });
      if (!isValid) return;
    }
    if (step === 1) {
      const isValid = validate({
        section: { rule: () => !!dish?.section_id },
        category: { rule: () => !!dish?.category_id },
      });
      if (!isValid) return;
    }
    if (step === 2) {
      handleUpdateDish({ menu_ids: [menuId] });
      try {
        if (dishId) {
          await putDish();
        } else {
          await postDish();
        }
        props.onClose();
      } catch {
        console.error('error');
      }
      return;
    }
    setStep(step + 1);
  };

  return { handleNextStep, handlePrevStep, step, t, isLoading };
};
